export const typography = {
  fontSize: {
    tiny: 12,
    extraSmall: 14,
    small: 16,
    medium: 18,
    large: 20,
    larger: 24,
    extraLarge: 28,
    huge: 36,
    extraHuge: 48,
    gigantic: 68,
    extraGigantic: 80
  },
  fontWeight: {
    regular: 400,
    semiBold: 500,
    bold: 700,
    extraBold: 800
  },
  lineHeight: {
    extraSmall: 1.2,
    small: 1.3,
    medium: 1.4,
    large: 1.6
  },
  letterSpacing: {
    Eyebrow: 2,
    Widest: 0,
    Wider: -0.5,
    Wide: -1,
    Thin: -1.5,
    Thinner: -2,
    Thinnest: -2.5
  }
};
